import { toast as hotToast } from 'react-hot-toast';

export type UploadResult = {
  uploadedCount?: number;
  failedFiles?: string[];
};

export function showUploadResult(result: UploadResult): void {
  const failed = result.failedFiles ?? [];
  const uploaded = result.uploadedCount ?? 0;

  if (failed.length > 0) {
    const failedList = failed.join(', ');
    const part = uploaded > 0 ? `${uploaded} file(s) uploaded. ` : '';
    hotToast.error(`${part}The following could not be uploaded: ${failedList}`);
  } else {
    hotToast.success(uploaded > 0 ? 'Upload successful.' : 'Upload complete.');
  }
}

export { hotToast as toast };
